<template>
  <div class="ru-list-container" data-testid="ru-list-after-filter">
    <div class="ru-list-content-wrapper">
      <div class="ru-list-scrollable-content">
        <!-- Card View: skeleton ↔ content cross-fade -->
        <transition name="ru-content-fade" mode="out-in">
        <!-- Loading state for Card View (view === 1) -->
        <div v-if="loading && view === 1" key="card-skeleton" class="pa-6" data-testid="ru-list-after-filter__card-view-loader">
          <div class="d-flex flex-wrap justify-center">
             <v-card v-for="n in 8" :key="n" class="ma-3" width="320" outlined>
               <v-card-text>
                 <v-skeleton-loader type="list-item-avatar-two-line, actions"></v-skeleton-loader>
               </v-card-text>
             </v-card>
          </div>
        </div>
        <!-- <div class="title grey--text text-center">Select a {{type}}</div> -->
        <div class="text-center" v-else-if="view === 1 && previousData.length > 0" key="card-content">
          <transition-group
            name="ru-card"
            tag="div"
            class="d-flex flex-wrap justify-center"
            ref="cardScrollContainer"
            @scroll.native="handleScroll"
            data-testid="ru-list-after-filter__card-container">
            <div class="" v-for="(v, k) in data" :key="v._id || k">
              <v-card class="ma-3 text-left scrollable-card" v-ripple @click="sendEvent('click', v)"
                data-testid="ru-list-after-filter__card">
                <v-card-text class="border-on hoverable cursor-pointer">
                  <div class="d-flex align-center">
                    <div>
                      <div class="font-size-md font-weight-bold" data-testid="ru-list-after-filter__card-name">{{v.name}}</div>
                      <div class="font-weight-bold d-flex align-center">
                        <h2 class="mr-1 font-weight-medium grey--text text--darken-1" data-testid="ru-list-after-filter__card-ru-count">{{v.rucount}}</h2>
                        <span style="line-height:1.3" class="caption">{{$nova.labelsName('access_management','ru_entity_plural_label','Reporting units')}}</span>
                      </div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="ml-4">
                      <v-progress-circular :size="55" :width="10" color="success"
                        :value="(Number(v.regional_ru_approve)/Number(v.rucount))*100" data-testid="ru-list-after-filter__card-progress">
                        {{ ((Number(v.regional_ru_approve)/Number(v.rucount))*100).toFixed(0) }}%
                      </v-progress-circular>
                    </div>
                  </div>
                  <div class="d-flex mt-2">
                    <v-spacer></v-spacer>
                    <v-tooltip bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="mx-3 d-flex align-center" data-testid="ru-list-after-filter__card-status-local">
                          <v-icon color="success">mdi-check-circle</v-icon>
                          <span class="body-1 ml-1">{{v.local_ru_approve}}</span>
                        </div>
                      </template>
                      <span>RU Approved at Locally</span>
                    </v-tooltip>
                    <!-- <v-tooltip bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="mx-3 d-flex align-center">
                          <v-icon>mdi-circle-off-outline</v-icon>
                          <span class="body-1 ml-1">{{v.cyclefreez}}</span>
                        </div>
                      </template>
                      <span>Freeze</span>
                    </v-tooltip> -->
                    <v-tooltip bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="mx-3 d-flex align-center" data-testid="ru-list-after-filter__card-status-regional">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                          <span class="body-1 ml-1">{{v.regional_ru_approve}}</span>
                        </div>
                      </template>
                      <span>{{$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional')}} {{$nova.labelsName('cycle_page', 'commenrary_ru_label', 'RU')}} Approval Done</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </transition-group>
        </div>
        </transition>
        <div class="" v-if="(view === 0 || view === 2) ">

          <div class="d-flex" v-if="totalPageCount > 1">
            <v-spacer />
            <div class="radius-small border-on" v-if="view === 2">
              <base-button icon="mdi-chevron-left" :disabled="page === 1" @click="changePageByStep(-1)" data-testid="ru-list-after-filter__top-prev-btn" />
              <span class="mx-1">Page {{page}} of {{totalPageCount}}</span>
              <base-button icon="mdi-chevron-right" :disabled="page === totalPageCount" @click="changePageByStep(1)" data-testid="ru-list-after-filter__top-next-btn" />
            </div>
          </div>
          <div
            v-show="shouldRenderTable"
            class="table-scroll-wrapper"
            ref="tableScrollContainer"
            @scroll="handleScroll"
            data-testid="ru-list-after-filter__table-container"
          >
            <div v-if="loading || dataLoading" class="ru-table-fade-layer">
              <lb-datatablenew
                :headers="headers"
                :items="shimmerItems"
                :loading="false"
                :bypass-filtering="true"
                :multiselectkey="shouldShowSelectionColumn ? '_id' : ''"
                :enableslot="['serial_number', 'l1_status', 'l2_status', 'user_role', 'reporting_unit']"
                data-testid="ru-list-after-filter__table-shimmer"
              >
                <template v-slot:serial_number>
                   <v-skeleton-loader class="my-3" type="text" />
                </template>
                <template v-slot:l1_status>
                   <v-skeleton-loader class="my-3" type="text" />
                </template>
                <template v-slot:l2_status>
                   <v-skeleton-loader class="my-3" type="text" />
                </template>
                <template v-slot:user_role>
                   <v-skeleton-loader class="my-3" type="text" />
                </template>
                <template v-slot:reporting_unit>
                   <v-skeleton-loader class="my-3" width="300" type="text" />
                </template>
              </lb-datatablenew>
            </div>
            
            <div v-show="!loading && !dataLoading" class="ru-table-fade-layer" :class="{ 'ru-table-entered': !loading && !dataLoading }">
              <lb-datatablenew
                ref="analysisTable"
                :headers="headers"
                :items="tableItems"
                :multiselectkey="shouldShowSelectionColumn ? '_id' : ''"
                :selecteditems="selectedlocalapproval"
                :loading="loading || dataLoading"
                :bypass-filtering="true"
                :enableslot="['l1_status', 'l2_status', 'reporting_unit']"
                @selectItem="updateSelection"
                @update:filters="handleTableFilterUpdate"
                data-testid="ru-list-after-filter__table"
              >
                <template v-slot:l1_status="{ item }">
                  <div class="status-cell" data-testid="ru-list-after-filter__approval-status-local">
                    <StatusIndicator v-bind="resolveApprovalStatus(item._l1_status_data, 'local')" size="sm" />
                    <ApprovalStatus
                      v-if="!isWorkflowDisabled(item._l1_status_data, 'local')"
                      :sub-approved="getMetricCount(item._l1_status_data, 'local', 'submitted')"
                      :sub-total="getMetricTotal(item._l1_status_data, 'local')"
                      :app-approved="getMetricCount(item._l1_status_data, 'local', 'approved')"
                      :app-total="getMetricTotal(item._l1_status_data, 'local')"
                      data-test-id="ru-list-after-filter__local-metrics"
                    />
                  </div>
                </template>
                <template v-slot:l2_status="{ item }">
                  <div class="status-cell" data-testid="ru-list-after-filter__approval-status-regional">
                    <StatusIndicator v-bind="resolveApprovalStatus(item._l2_status_data, 'regional')" size="sm" />
                    <ApprovalStatus
                      v-if="!isWorkflowDisabled(item._l2_status_data, 'regional')"
                      :sub-approved="getMetricCount(item._l2_status_data, 'regional', 'submitted')"
                      :sub-total="getMetricTotal(item._l2_status_data, 'regional')"
                      :app-approved="getMetricCount(item._l2_status_data, 'regional', 'approved')"
                      :app-total="getMetricTotal(item._l2_status_data, 'regional')"
                      data-test-id="ru-list-after-filter__regional-metrics"
                    />
                  </div>
                </template>
                <template v-slot:reporting_unit="{ item }">
                  <div class="d-flex align-center justify-space-between gap-10">
                    <div>
                      <span class="report-unit-data" data-testid="ru-list-after-filter__ru-name"><span class="">{{item._reporting_unit_data.reportingunit_detail && item._reporting_unit_data.reportingunit_detail.code}}</span> - {{item._reporting_unit_data.reportingunit_detail.name}}</span>
                      <div class="grey--text text--darken-2" v-if="type !== 'Reporting Unit'" data-testid="ru-list-after-filter__ru-count-info">
                        <span class="mr-1">{{item._reporting_unit_data.rucount || 0}}</span>
                        <span>{{$nova.labelsName('materiality_page','ru_entity_plural_label','Reporting Units')}}</span>
                      </div>
                    </div>
                    <div class="d-flex align-center gap-2" @click.stop>
                      <div class="action-icons d-flex align-center gap-2">
                        <v-tooltip bottom content-class="tooltip-bottom" v-if="shouldShowLocalApprovalIcon(item._reporting_unit_data)">
                          <template v-slot:activator="{ on, attrs }">
                            <base-button
                              icon-style
                              small
                              image="/img/icons/ReginonalApprovalIcon.svg"
                              image-alt="Approvals Icon"
                              v-bind="attrs"
                              v-on="on"
                              @click.stop="openApprovalDialog(item._reporting_unit_data, 'local')"
                              data-testid="ru-list-after-filter__local-ru-approval-ready"
                            />
                          </template>
                          <span>Ready for local RU approval</span>
                        </v-tooltip>
                        <v-tooltip bottom content-class="tooltip-bottom" v-if="shouldShowRegionalApprovalIcon(item._reporting_unit_data)">
                          <template v-slot:activator="{ on, attrs }">
                            <base-button
                              icon-style
                              small
                              image="/img/icons/ReginonalApprovalIcon.svg"
                              image-alt="Approvals Icon"
                              v-bind="attrs"
                              v-on="on"
                              @click.stop="openApprovalDialog(item._reporting_unit_data, 'regional')"
                              data-testid="ru-list-after-filter__regional-ru-approval-ready"
                            />
                          </template>
                          <span>Ready for regional RU approval</span>
                        </v-tooltip>
                        <v-tooltip bottom content-class="tooltip-bottom" v-if="shouldShowMailReminderIcon(item._reporting_unit_data)">
                          <template v-slot:activator="{ on, attrs }">
                            <base-button
                              icon-style
                              small
                              image="/img/icons/EmailIcon.svg"
                              image-alt="Email Icon"
                              v-bind="attrs"
                              v-on="on"
                              @click.stop="openEmailDialog(item._reporting_unit_data)"
                              data-testid="ru-list-after-filter__mail-reminder"
                            />
                          </template>
                          <span>Send Email Reminder</span>
                        </v-tooltip>
                        <v-tooltip bottom content-class="tooltip-bottom">
                          <template v-slot:activator="{ on, attrs }">
                            <base-button
                              icon-style
                              small
                              image="/img/icons/EyeIcon.svg"
                              image-alt="View Details Icon"
                              v-bind="attrs"
                              v-on="on"
                              @click.stop="getApproveRUData(getCycleId(item._reporting_unit_data))"
                              data-testid="ru-list-after-filter__view-details-action"
                            />
                          </template>
                          <span>View details</span>
                        </v-tooltip>
                        <span
                          style="display: flex; align-items: center; width:28px;  justify-content:center;"
                          @click.stop
                          data-testid="ru-list-after-filter__activity-log-action"
                        >
                          <lb-activitylog :config="activitylogconfigcycle"
                            icon="/img/icons/ActivityLogIcons.svg"
                            :url="`/v3/varianceanalysis/analysis/getlogs/${getCycleId(item._reporting_unit_data)}/f/${cycletype}`"
                            contentClass="tooltip-bottom-right" class="activity-img" />
                        </span>
                      </div>
                      <v-divider vertical></v-divider>
                      <base-button
                        icon-style
                        small
                        image="/img/icons/downArrow.svg"
                        image-alt=""
                        :class="{ 'accordion-chevron-rotated': item._reporting_unit_data._expanded, 'accordion-chevron': true }"
                        @click.stop="toggleAccordion(item._reporting_unit_data)"
                        data-testid="ru-list-after-filter__accordion-toggle-action"
                      />
                    </div>
                  </div>
                </template>
                <template v-slot:row-after="{ item }">
                  <WorkflowAccordion
                    :is-expanded="item._expanded"
                    :is-loading="item._loading"
                    :summary-loaded="item._summaryLoaded"
                    :row-data="item"
                    :row-index="item.indexno"
                    :column-count="tableColumnCount"
                    data-testid="ru-list-after-filter__workflow-accordion"
                  />
                </template>
              </lb-datatablenew>
            </div>
          </div>
          <transition name="ru-content-fade">
          <NoDataState
            v-if="!shouldRenderTable"
            class="pa-6"
            data-testid="ru-list-after-filter__no-data-placeholder"
            :title="filterNoDataTitle"
            :description="filterNoDataDescription"
            :showReset="true"
            :resetLabel="filterNoDataCta"
            @reset="handleResetView"
          >
          </NoDataState>
          </transition>
        </div>
        <div v-if="loading && view !== 1 && view !== 0 && view !== 2" class="pa-6 text-center" data-testid="ru-list-after-filter__fallback-loader">
          <span class="dots-loader">Please wait as we load your data<span>.</span><span>.</span><span>.</span></span>
        </div>
        <transition name="ru-content-fade">
        <NoDataState
          v-if="!loading && previousData.length === 0 && view !== 1 && view !== 0 && view !== 2"
          class="pa-6"
          data-testid="ru-list-after-filter__no-data-placeholder"
          :title="filterNoDataTitle"
          :description="filterNoDataDescription"
          :showReset="true"
          :resetLabel="filterNoDataCta"
          @reset="handleResetView"
        />
        </transition>
      </div>
      <!-- Pagination wrapper - positioned outside scrollable content -->
      <Pagination
        v-if="totalPageCount > 1 && (view === 0 || view === 2)"
        v-model="page"
        :list="[]"
        :itemsperpage="perpage"
        :length-override="totalPageCount"
        :hide-on-single-page="false"
        :disabled="loading || dataLoading"
        @paginated-data="handlePaginationPageChange"
        data-testid="ru-list-after-filter__pagination"
      />
    </div>
    <lb-dialog v-model="emailDialog" :heading="'Send Email Notifications'" width="400" data-testid="ru-list-after-filter__email-dialog">
      <template v-slot:body>
        <div class="">Are you sure you want to send email notifications for this reporting unit?</div>
      </template>
      <template v-slot:actions>
        <base-button primary @click="proceedSendEmail" label="Proceed" data-testid="ru-list-after-filter__email-proceed" />
      </template>
    </lb-dialog>
    <RUApprovalDialog
      v-model="showApprovalDialog"
      :loading="approvalLoading"
      :heading="approvalType === 'local' 
        ? `${$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local')} Approval` 
        : `${$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional')} Approval`"
      :approval-type="approvalType"
      :note.sync="approvalNote"
      :eligible-reporting-units="approvalEligibleRUs"
      @proceed="handleApprovalProceed"
    />
    <lb-dialog v-model="approveRUDataDialogue" :heading="`${$nova.labelsName('cycle_page', 'commenrary_ru_label', 'RU')} Approval data`" :loading="approveRUDataloading" width='800' data-testid="ru-list-after-filter__approval-details-dialog">
      <template v-slot:body>
        <div class="d-flex flex-column gap-4">
          <div class="d-flex flex-column gap-2">
            <h4 class="font-weight-medium"> {{ $nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local') }} Approval Reason</h4>
            <span class="reason-comment" v-if="approveRUData.local_ru_approve_comment" data-testid="ru-list-after-filter__local-approve-comment">
              {{ approveRUData.local_ru_approve_comment }}</span>
            <span class="" v-else>{{ noApprovalCommentCopy }}</span>
          </div>
          <div class="d-flex flex-column gap-2">
            <h4 class="font-weight-medium"> {{ $nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') }} Approval Reason</h4>
            <span class="reason-comment" v-if="approveRUData.regional_ru_approve_comment" data-testid="ru-list-after-filter__regional-approve-comment">
              {{ approveRUData.regional_ru_approve_comment }}</span>
            <span class="" v-else>{{ noApprovalCommentCopy }}</span>
          </div>
        </div>
      </template>
    </lb-dialog>
  </div>
</template>

<script>
import varianceAnalysisConstants from '../../constants';
import StatusIndicator from '../../components/StatusIndicator.vue';
import ApprovalStatus from '../../components/ApprovalStatus.vue';
import NoDataState from '../../components/NoDataState.vue';
import WorkflowAccordion from '../../components/WorkflowAccordion.vue';
import RUApprovalDialog from '../../modals/RUApprovalDialog.vue';
import helpers from '../../utils/helpers';
import { STATUS_CONFIG, DEFAULT_STATUS_VARIANT, STATUS_CODE_VARIANT_MAP, STATUS_VARIANTS, STATUS_CODE_VARIANT_MAP_REGIONAL } from '../../utils/statusConstants';
import { getStatusVariantByCode, getStatusLabelByCode } from '../../utils/statusHelpers';
import { VARIANCE_ANALYSIS_UI } from '../../utils/constants';
import Pagination from '../../../../views/common/Pagination.vue';

export default {
  name: 'ru_list_after_filter',
  components: {
    Pagination,
    StatusIndicator,
    ApprovalStatus,
    NoDataState,
    WorkflowAccordion,
    RUApprovalDialog,
  },
  data: function(){
    return {
      pageName:"cycle_page",
      userid: '',
      page: 1,
      perpage: Number(this.pageSize) || varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE,
      previousData:this.data || [],
      paginatedData: [],
      selectedlocalapproval: [],
      selectedregionalapproval: [],
      selectedReportingUnits: [],
      dataLoading: false,
      pendingPage: null,
      lastLoadedPage: 1,
      isApplyingExternalPage: false,
      /** @type {number} Request token to track the latest pagination request and ignore stale responses */
      paginationRequestToken: 0,
      /** @type {number|null} Debounce timer for pagination clicks */
      paginationDebounceTimer: null,
      /** @type {boolean} Flag to ignore pagination events while processing API response */
      isProcessingResponse: false,
      filterData:[],
      container: null,
      approveRUData:{},
      approveRUDataloading:false,
      approveRUDataDialogue:false,
      activitylogconfigcycle: {
        cycleopen: { icon: "mdi-circle-outline", color: "grey" },
        cycleclose: { icon: "mdi-circle", color: "grey" }
      },
      selectedHeader:"rucode",
      seachFilter: "",
      selectedFilterItems:[],
      appname:"",
      reportingunit_list : [],
      tab:'tab-1',
      filterValue:[],
      isfilteredData:false,
      tableHeight:'',
      filterDebounceTimer: null,
      multipleRoles:varianceAnalysisConstants.MESSAGES.MULTIPLE_ROLES || '',
      allSelected: false,
      isIndeterminate: false,
      // Track loading state for each accordion row by cycle id
      accordionLoadingMap: {},
      // Email dialog state
      emailDialog: false,
      emailDialogRU: null,
      // Approval dialog state
      showApprovalDialog: false,
      approvalType: 'local',
      approvalNote: '',
      approvalEligibleRUs: [],
      approvalLoading: false,
      approvalRU: null,
      suppressFilterUpdate: false,
      isTableFilterTriggered: false,
    }
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: "",
    },
    view: {
      type: Number,
      default: 0,
    },
    enablecheckboxlocal: {
      type: Boolean,
      default: false,
    },
    enablecheckboxregional: {
      type: Boolean,
      default: false,
    },
    enableMailSenderCheckbox: {
      type: Boolean,
      default: false,
    },
    loading:{
      type: Boolean,
      default: false,
    },
    cycletype:{
      type:String,
      default:'Actual'
    },
    isDataRefreshed:{
      type:Boolean,
      default:false
    },
    hasMore: {
      type: Boolean,
      default: true,
    },
    pageSize: {
      type: Number,
      default: () => varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  activated() {
    this.refreshData();
    // Removed auto-load - only load more on user scroll
  },
  mounted() {
    this.appname = "m_" + (this.$route.path || "").split("/")[1] || "";
    this.refreshData();
    // Listen to window scroll so infinite scroll works when the page itself scrolls
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }
  },
  computed:{
    availableRoles() {
      const hierarchyData = this.cycletype === 'Forecast' 
        ? (this.$store.state[this.appname] || {}).forecasthierarchydata 
        : (this.$store.state[this.appname] || {}).actualhierarchydata;
      
      const rawRoles = hierarchyData?.possibleroles || hierarchyData?.possibleRoles || hierarchyData?.rolelist || [];
      
      const roleLabels = {
        'submitter': this.$nova.labelsName('cycle_page','commentary_local_preparer_label','Local Preparer'),
        'approver': this.$nova.labelsName('cycle_page','commentary_local_approver_label','Local Approver'),
        'regional_approver': this.$nova.labelsName('cycle_page','commentary_regional_approver_label','Regional Approver'),
        'manager': 'Manager',
        'view_only': 'View Only',
        'multiple_roles': varianceAnalysisConstants.MESSAGES.MULTIPLE_ROLES || 'Multiple Roles'
      };

      let processedRoles = [];

      if (Array.isArray(rawRoles) && rawRoles.length > 0) {
        processedRoles = rawRoles
          .filter(role => {
             const id = (typeof role === 'object' && role !== null) ? role._id : role;
             return id !== 'all';
          })
          .map(role => {
             const id = (typeof role === 'object' && role !== null) ? role._id : role;
             // Prefer standard label if known ID, else use API name, else ID
             const name = roleLabels[id] || (typeof role === 'object' && (role.name || role.label) ? (role.name || role.label) : id);
             return { _id: id, name: name };
          });
      } else {
        processedRoles = [
            { _id: 'submitter', name: roleLabels['submitter'] },
            { _id: 'approver', name: roleLabels['approver'] },
            { _id: 'regional_approver', name: roleLabels['regional_approver'] },
            { _id: 'manager', name: roleLabels['manager'] }
        ];
      }

      // Ensure "View Only" and "Multiple Roles" are present if not already
      const existingIds = new Set(processedRoles.map(r => r._id));
      
      if (!existingIds.has('view_only')) {
        processedRoles.push({ _id: 'view_only', name: roleLabels['view_only'] });
      }
      
      if (!existingIds.has('multiple_roles')) {
        processedRoles.push({ _id: 'multiple_roles', name: roleLabels['multiple_roles'] });
      }

      return processedRoles;
    },
    headers() {
      return [
        { text: 'S.No', value: 'serial_number', sortable: false, width: '60px', align: 'center', },
        { 
          text: `${this.$nova.labelsName('my_reporting_units_page', 'commentary_local_key_label', 'Local')} ${this.$nova.labelsName('my_reporting_units_page', 'commenrary_ru_label', 'RU')} Status`, 
          value: 'l1_status', 
          sortable: false, 
          filterable: true,
          disableFilterSearch: true, 
          width: '180px',
          filterList: ['In Local Review', 'Approved', 'Workflow Disabled']
        },
        { text: `${this.$nova.labelsName('my_reporting_units_page', 'commentary_regional_key_label', 'Regional')} ${this.$nova.labelsName('my_reporting_units_page', 'commenrary_ru_label', 'RU')} Status`, 
          value: 'l2_status', sortable: false, filterable: true, disableFilterSearch: true, width: '200px',
          filterList: ['In Regional Review', 'Approved', 'Workflow Disabled']
        },
        { text: 'User Role', value: 'user_role', sortable: false, filterable: true, disableFilterSearch: true, width: '180px',
          filterList: this.availableRoles.map(r => r.name)
        },
        { text: 'Reporting Unit', value: 'reporting_unit', sortable: false },
      ]
    },
    shimmerItems() {
      return Array.from({ length: 8 }, (_, i) => ({ _id: `shimmer-${i}`, _selectable: false }));
    },
    filtereddata() {
      const source = Array.isArray(this.previousData) ? this.previousData : [];
      if (this.isPaginationActive) {
        return source.slice(0, this.perpage);
      }
      return source;
    },
    filterNoDataTitle() {
      return VARIANCE_ANALYSIS_UI.FILTER_NO_DATA_TITLE;
    },
    filterNoDataDescription() {
      return VARIANCE_ANALYSIS_UI.FILTER_NO_DATA_DESCRIPTION;
    },
    filterNoDataCta() {
      return VARIANCE_ANALYSIS_UI.FILTER_NO_DATA_CTA;
    },
    filterNoDataSlotCopy() {
      return VARIANCE_ANALYSIS_UI.FILTER_NO_DATA_SLOT_COPY;
    },
    noApprovalCommentCopy() {
      return VARIANCE_ANALYSIS_UI.NO_APPROVAL_COMMENT;
    },
    // Calculate total page count from API totalCount
    totalPageCount() {
      const safePerPage = Math.max(1, Number(this.perpage) || varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE);
      return Math.ceil((this.totalCount || 0) / safePerPage) || 1;
    },
    isPaginationActive() {
      const safeTotal = Number(this.totalCount) || 0;
      return safeTotal > 0 || (Array.isArray(this.previousData) && this.previousData.length > this.perpage);
    },
    shouldRenderTable() {
      if (this.loading || this.dataLoading) {
        return true;
      }
      return Array.isArray(this.filtereddata) && this.filtereddata.length > 0;
    },
    currentPageCycles() {
      return (this.filtereddata || [])
        .filter(item => this.shouldRenderRowCheckbox(item))
        .map(item => this.getCycleId(item));
    },
    shouldShowSelectionColumn() {
      if (!this.enablecheckboxlocal && !this.enablecheckboxregional && !this.enableMailSenderCheckbox) {
        return false;
      }
      return true;
    },
    tableColumnCount() {
      return this.shouldShowSelectionColumn ? 6 : 5;
    },
    tableItems() {
      return this.filtereddata.map((item, index) => {
        // Compute status labels for filtering
        const l1StatusInfo = this.resolveApprovalStatus(item, 'local');
        const l2StatusInfo = this.resolveApprovalStatus(item, 'regional');
        const ruDetail = item.reportingunit_detail || {};
        
        return {
          ...item,
          indexno: index,
          serial_number: ((this.page - 1) * this.perpage) + index + 1,
          _id: this.getCycleId(item), // Ensure _id is set for multiselectkey
          _selectable: this.shouldRenderRowCheckbox(item), // Control checkbox visibility
          l1_status: l1StatusInfo.customLabel || '-', // String for filtering
          l2_status: l2StatusInfo.customLabel || '-', // String for filtering
          _l1_status_data: item, // Full item for slot rendering
          _l2_status_data: item, // Full item for slot rendering
          user_role: this.type === 'Reporting Unit' ? this.getUserRole(item) : (item.userRole || '-'),
          reporting_unit: `${ruDetail.code || ''} - ${ruDetail.name || ''}`.trim() || '-', // String for filtering
          _reporting_unit_data: item, // Full item for slot rendering
          __click: () => this.handleRowClick(item),
        };
      });
    },
  },
  created(){
    this.tableHeight = window.innerHeight-213 ;    
  },
  methods: {
    resolveHierarchyId(source) {
      if (source === null || source === undefined) {
        return null;
      }
      if (typeof source === 'string' || typeof source === 'number') {
        return source;
      }
      if (typeof source === 'object') {
        // Handle array wrapper case
        if (Array.isArray(source) && source.length > 0) {
           return this.resolveHierarchyId(source[0]);
        }
        return source._id || source.id || source.value || null;
      }
      return null;
    },
    openEmailDialog(row) {
      this.emailDialogRU = row;
      this.emailDialog = true;
    },
    closeEmailDialog() {
      this.emailDialog = false;
      this.emailDialogRU = null;
    },
    proceedSendEmail() {
      // You can emit or call API here
      this.$emit('sendRemainderMail', this.getCycleId(this.emailDialogRU));
      this.closeEmailDialog();
    },
    updateSelection(items) {
      this.selectedlocalapproval = items;
      this.updateIndeterminate();
    },
    handleResetView() {
      this.$emit('reset-filters');
    },
    openApprovalDialog(item, type) {
      this.approvalType = type;
      this.approvalRU = item; // Keep reference to raw item
      
      const ruDetail = item.reportingunit_detail || {};
      
      // Mirroring behavior from helpers.js (used in Base.vue) to show standard approval declaration
      // Using helper method call on dummy context to extract the exact text without code duplication
      const dummyContext = {};
      if (type === 'local') {
        helpers.approveLocalRU.call(dummyContext);
      } else if (type === 'regional') {
        helpers.approveRegionalRU.call(dummyContext);
      }
      this.approvalNote = dummyContext.rulevelapprovenote || '';
      
      const l1Approval = this.resolveApprovalStatus(item, 'local');
      const l2Approval = this.resolveApprovalStatus(item, 'regional');
      
      // Helper to extract raw status code exactly like resolveApprovalStatus does
      const getRawCode = (unit, level) => {
        const cycleDetail = unit?.cycle_detail || {};
        const statusKey = level === 'local' ? 'localRuLevelApprovalStatus' : 'regionalRuLevelApprovalStatus';
        const legacyKey = level === 'local' ? 'local_ru_approve' : 'regional_ru_approve';
        const candidates = [
          cycleDetail[statusKey],
          unit?.[statusKey],
          cycleDetail[legacyKey],
          unit?.[legacyKey],
        ];
        return candidates.find(value => [0, 1, 2, 3].includes(Number(value)));
      };

      const l1Status = getRawCode(item, 'local');
      const l2Status = getRawCode(item, 'regional');

      this.approvalEligibleRUs = [{
        cycleId: this.getCycleId(item),
        code: ruDetail.code,
        name: ruDetail.name,
        l1Status: l1Status,
        l1StatusLabel: l1Approval.customLabel,
        l1StatusVariant: l1Approval.variant,
        l2Status: l2Status,
        l2StatusLabel: l2Approval.customLabel,
        l2StatusVariant: l2Approval.variant,
        userRole: this.type === 'Reporting Unit' ? this.getUserRole(item) : (item.userRole || '-')
      }];
      
      this.showApprovalDialog = true;
    },
    handleApprovalProceed() {
      this.approvalLoading = true;
      const url = "/v3/varianceanalysis/analysis/rulevelapproval/";
      const cycleIds = [this.getCycleId(this.approvalRU)];
      
      const ruApprovalFilter = { 
        type: this.approvalType, 
        cycleids: cycleIds, 
        cycletype: this.cycletype 
      };
      
      this.axios.post(url, { 
        filter: ruApprovalFilter, 
        data: { approvalcomment: this.approvalNote } 
      }).then(dt => {
        if (dt.data.status === "success") {
          this.$store.commit("sbSuccess", "RU level approval done", { root: true });
          this.$emit('getreportingunit', { page: this.page, limit: this.perpage }); 
          this.showApprovalDialog = false;
        } else {
           this.$store.commit("sbError", dt.data.message || "Approval failed", { root: true });
        }
      }).catch(err => {
        this.$store.commit("sbError", err.message || "Approval failed", { root: true });
      }).finally(() => {
        this.approvalLoading = false;
      });
    },
    /**
     * Handles accordion toggle with API call for cycle summaries
     * Fetches data on expand, collapses without API call
     * @param {Object} row - The row data object
     */
    async toggleAccordion(row) {
      // Get cycle ID using helper method
      const cycleId = this.getCycleId(row);
      // Get reporting unit ID from reportingunit_detail._id
      const reportingunitId = row.reportingunit_detail?._id || row.reportingunit || row._id;
      // Get period from filters in store
      const filters = this.cycletype === 'Forecast' 
        ? this.$store.state[this.appname]?.forecastfilter 
        : this.$store.state[this.appname]?.actualfilter;
      const period = filters?.selectedperiod || '';
      
      const isExpanding = !row._expanded;

      // Toggle the expanded state
      this.$set(row, '_expanded', isExpanding);

      // Only fetch data when expanding and data not already loaded
      if (isExpanding && !row._summaryLoaded && cycleId) {
        this.$set(this.accordionLoadingMap, cycleId, true);
        this.$set(row, '_loading', true);

        try {
          const summaryData = await this.$store.dispatch(
            'varianceanalysis/reportingUnit/getCycleSummaries',
            {
              cycleIds: [cycleId],
              reportingunit: reportingunitId,
              period: period,
              cycletype: this.cycletype,
              axiosInstance: this.axios
            }
          );

          // Merge the fetched summary data into the row object
          if (summaryData && summaryData.length > 0) {
            const data = summaryData[0];
            Object.keys(data).forEach(key => {
              this.$set(row, key, data[key]);
            });
          }

          this.$set(row, '_summaryLoaded', true);
        } catch (error) {
          console.error('[List.vue] Failed to fetch cycle summaries:', error);
          // Collapse the accordion on error
          this.$set(row, '_expanded', false);
        } finally {
          this.$set(this.accordionLoadingMap, cycleId, false);
          this.$set(row, '_loading', false);
        }
      }
    },
    /**
     * Checks if the accordion row is currently loading
     * @param {Object} row - The row data object
     * @returns {boolean} - True if the row is loading
     */
    isAccordionLoading(row) {
      return this.accordionLoadingMap[this.getCycleId(row)] || false;
    },
    /**
     * Gets the cycle ID from the row object
     * Handles both old API format (v.cycle) and new API format (v.cycle_detail._id)
     * @param {Object} row - The row data object
     * @returns {string|null} - The cycle ID
     */
    getCycleId(row) {
      if (!row) return null;
      return row.cycle_detail?._id || row.cycle || row._id || null;
    },
    handleRowClick(unit) {
      if (!unit) {
        return;
      }
      this.sendEvent('click', unit);
    },
    /**
     * Clears selection-driven state so pagination requests start cleanly.
     */
    resetSelectionState() {
      this.selectedlocalapproval = [];
      this.selectedregionalapproval = [];
      this.selectedReportingUnits = [];
      this.allSelected = false;
      this.isIndeterminate = false;
    },
    /**
     * Toggles an individual reporting unit selection without affecting others.
     * @param {string|number} cycleId
     */
    toggleRowSelection(cycleId, isChecked) {
      if (!cycleId) {
        return;
      }
      const current = new Set(this.selectedlocalapproval);
      const shouldSelect = Boolean(isChecked);
      if (shouldSelect) {
        current.add(cycleId);
      } else {
        current.delete(cycleId);
      }
      this.selectedlocalapproval = Array.from(current);
      this.updateIndeterminate();
    },
    // Handle pagination page change by requesting fresh data from parent
    // Uses debouncing to prevent rapid clicks from triggering multiple API calls
    handlePaginationPageChange(payload = {}) {
      const safePage = Math.max(1, Number(payload.page) || 1);
      
      // Skip pagination-triggered fetches during an active refresh operation
      if (this.isDataRefreshed) {
        return;
      }
      
      // Skip if this is a programmatic page sync from parent
      if (this.isApplyingExternalPage) {
        this.isApplyingExternalPage = false;
        this.pendingPage = null;
        return;
      }
      
      // Skip if we're currently processing an API response (prevents feedback loop)
      if (this.isProcessingResponse) {
        return;
      }
      
      // Skip if already loading this exact page
      if (this.dataLoading && this.pendingPage === safePage) {
        return;
      }
      
      // Skip if already on this page with data loaded and no pending request
      if (!this.dataLoading && safePage === this.lastLoadedPage) {
        return;
      }
      
      // Clear any pending debounce timer
      if (this.paginationDebounceTimer) {
        clearTimeout(this.paginationDebounceTimer);
        this.paginationDebounceTimer = null;
      }
      
      // Update page immediately for UI feedback
      if (this.page !== safePage) {
        this.page = safePage;
      }
      
      // Debounce the actual API call to prevent rapid clicks from causing loops
      this.paginationDebounceTimer = setTimeout(() => {
        this.paginationDebounceTimer = null;
        this.executePaginationRequest(safePage);
      }, 150);
    },
    /**
     * Execute the actual pagination API request after debouncing
     * @param {number} targetPage - The page to load
     */
    executePaginationRequest(targetPage) {
      // Increment request token to invalidate any in-flight requests
      this.paginationRequestToken = (this.paginationRequestToken || 0) + 1;
      
      // Set pending state
      this.pendingPage = targetPage;
      this.dataLoading = true;
      this.resetSelectionState();
      
      // Emit request to parent
      this.$emit('getreportingunit', { page: targetPage, limit: this.perpage });
      this.$emit('page-change', targetPage);
    },
    changePageByStep(step = 0) {
      const targetPage = this.page + step;
      if (targetPage < 1 || targetPage > this.totalPageCount) {
        return;
      }
      this.page = targetPage;
    },
    updatePaginationMeta() {
      const safePerPage = Math.max(1, Number(this.perpage) || varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE);
      if (safePerPage !== this.perpage) {
        this.perpage = safePerPage;
      }
      // For server-side pagination, pagecount is calculated from totalCount in computed property
      // No need to slice data here - data comes from API
      this.pruneInvalidSelections();
      this.updateIndeterminate();
    },
    // Select all/deselect all logic for checkboxes
    toggleSelectAll(isChecked) {
      if (!this.shouldShowSelectionColumn) {
        this.resetSelectionState();
        return;
      }
      const shouldSelect = typeof isChecked === 'boolean' ? isChecked : Boolean(this.allSelected);
      this.allSelected = shouldSelect;
      this.selectedlocalapproval = shouldSelect ? [...this.currentPageCycles] : [];
      this.isIndeterminate = false;
      this.updateIndeterminate();
    },
    updateIndeterminate() {
      if (!this.shouldShowSelectionColumn) {
        this.isIndeterminate = false;
        this.allSelected = false;
        return;
      }
      const total = this.currentPageCycles.length;
      const selected = this.currentPageCycles.filter(cycle => this.selectedlocalapproval.includes(cycle)).length;
      this.isIndeterminate = selected > 0 && selected < total;
      this.allSelected = selected === total && total > 0;
    },
    // Maps approval code to readable label
    mapApprovalStatus(code) {
      return getStatusLabelByCode(code);
    },
    // Derive approval status from mixed payload shapes
    resolveApprovalStatus(unit, level) {
      const cycleDetail = unit?.cycle_detail || {};
      const statusKey = level === 'local' ? 'localRuLevelApprovalStatus' : 'regionalRuLevelApprovalStatus';
      const legacyKey = level === 'local' ? 'local_ru_approve' : 'regional_ru_approve';
      const candidates = [
        cycleDetail[statusKey],
        unit?.[statusKey],
        cycleDetail[legacyKey],
        unit?.[legacyKey],
      ];
      const match = candidates.find(value => [0, 1, 2, 3].includes(Number(value)));
      
      let variant;
      
      // Override for regional mapping to ensure correct labels
      if (level === 'regional' && match !== undefined) {
        const code = Number(match);
        if (code === 0) variant = STATUS_VARIANTS.REGIONAL_PENDING;
        else if (code === 1) variant = STATUS_VARIANTS.REGIONAL_PENDING;
        else if (code === 2) variant = STATUS_VARIANTS.APPROVED;
        else if (code === 3) variant = STATUS_VARIANTS.DISABLED;
      }
      
      if (!variant) {
        variant = getStatusVariantByCode(match);
      }

      const config = STATUS_CONFIG[variant] || STATUS_CONFIG[DEFAULT_STATUS_VARIANT];
      return {
        variant,
        customLabel: config.label,
      };
    },
    /**
     * Check if workflow is disabled for a given level
     * @param {Object} unit - The row data object
     * @param {String} level - 'local' or 'regional'
     * @returns {Boolean} - True if workflow is disabled (status === 3)
     */
    isWorkflowDisabled(unit, level) {
      const cycleDetail = unit?.cycle_detail || {};
      const statusKey = level === 'local' ? 'localRuLevelApprovalStatus' : 'regionalRuLevelApprovalStatus';
      const legacyKey = level === 'local' ? 'local_ru_approve' : 'regional_ru_approve';
      const candidates = [
        cycleDetail[statusKey],
        unit?.[statusKey],
        cycleDetail[legacyKey],
        unit?.[legacyKey],
      ];
      const match = candidates.find(value => [0, 1, 2, 3].includes(Number(value)));
      return Number(match) === 3;
    },

    /**
     * Get the raw count value for a specific metric (not percentage)
     * @param {Object} unit - The status data object
     * @param {String} level - 'local' or 'regional'
     * @param {String} metricType - 'submitted' (pendingapproval) or 'approved'
     * @returns {Number} - Raw count value
     */
    getMetricCount(unit, level, metricType) {
      if (!unit) return 0;
      
      let count = 0;
      if (metricType === 'submitted') {
        const proformaKey = `pendingapproval_${level}_proforma`;
        const forecastKey = `pendingapproval_${level}_forecast`;
        count = (Number(unit[proformaKey]) || 0) + (Number(unit[forecastKey]) || 0);
      } else if (metricType === 'approved') {
        const controlProformaKey = `control_approved_${level}_proforma`;
        const controlForecastKey = `control_approved_${level}_forecast`;
        const proformaKey = `approved_${level}_proforma`;
        const forecastKey = `approved_${level}_forecast`;
        
        const controlApproved = (Number(unit[controlProformaKey]) || 0) + (Number(unit[controlForecastKey]) || 0);
        const regularApproved = (Number(unit[proformaKey]) || 0) + (Number(unit[forecastKey]) || 0);
        count = controlApproved > 0 ? controlApproved : regularApproved;
      }
      return count;
    },

    /**
     * Get the total count for a level (denominator for metrics)
     * @param {Object} unit - The status data object
     * @param {String} level - 'local' or 'regional'
     * @returns {Number} - Total count
     */
    getMetricTotal(unit, level) {
      if (!unit) return 0;
      const countProformaKey = `control_count_${level}_proforma`;
      const countForecastKey = `control_count_${level}_forecast`;
      return (Number(unit[countProformaKey]) || 0) + (Number(unit[countForecastKey]) || 0);
    },

    shouldShowLocalApprovalIcon(unit) {
      if(!this.enablecheckboxlocal) return false;
      const ru = unit?.reportingunit_detail || {};
      const submitters = Array.isArray(ru.approver) ? ru.approver : [];
      const readiness = [
        unit?.cycle_detail?.isReadyForLocalRuLevelApproval,
        unit?.isReadyForLocalRuLevelApproval,
      ].find(flag => typeof flag === 'boolean' ? flag : undefined);
      return Boolean(readiness && submitters.includes(this.userid));
    },
    shouldShowRegionalApprovalIcon(unit) {
      if(!this.enablecheckboxregional) return false;
      const ru = unit?.reportingunit_detail || {};
      const regionalApprovers = Array.isArray(ru.regional_approver) ? ru.regional_approver : [];
      const readiness = [
        unit?.cycle_detail?.isReadyForRegionalRuLevelApproval,
        unit?.isReadyForRegionalRuLevelApproval,
      ].find(flag => typeof flag === 'boolean' ? flag : undefined);
      return Boolean(readiness && regionalApprovers.includes(this.userid));
    },
    shouldShowMailReminderIcon(unit) {
      if (!unit?.showMailReminderButton) {
        return false;
      }
      return (
        !this.shouldShowLocalApprovalIcon(unit) &&
        !this.shouldShowRegionalApprovalIcon(unit)
      );
    },
    // Determine whether the current row qualifies for a selectable checkbox.
    shouldRenderRowCheckbox(unit) {
      if (!unit) {
        return false;
      }
      if (this.enablecheckboxlocal && this.shouldShowLocalApprovalIcon(unit)) {
        return true;
      }
      if (this.enablecheckboxregional && this.shouldShowRegionalApprovalIcon(unit)) {
        return true;
      }
      if (this.enableMailSenderCheckbox && this.shouldShowMailReminderIcon(unit)) {
        return true;
      }
      return false;
    },
    // Remove any stale selections that are no longer eligible for interaction.
    pruneInvalidSelections() {
      const eligibleCycles = new Set(
        (this.previousData || [])
          .filter(item => this.shouldRenderRowCheckbox(item))
          .map(item => this.getCycleId(item))
      );
      const nextSelections = this.selectedlocalapproval.filter(cycle => eligibleCycles.has(cycle));
      if (nextSelections.length !== this.selectedlocalapproval.length) {
        this.selectedlocalapproval = nextSelections;
      }
    },
    getUserRole(v) {
      const ru = v.reportingunit_detail || {};
      if (this.userHasMultipleRoles(ru)) return this.multipleRoles;
      if (ru.submitter && ru.submitter.indexOf(this.userid) > -1)
        return this.$nova.labelsName('cycle_page','commentary_local_preparer_label','Local Preparer');
      if (ru.approver && ru.approver.indexOf(this.userid) > -1)
        return this.$nova.labelsName('cycle_page','commentary_local_approver_label','Local Approver');
      if (ru.regional_approver && ru.regional_approver.indexOf(this.userid) > -1)
        return this.$nova.labelsName('cycle_page','commentary_regional_approver_label','Regional Approver');
      if (ru.manager && ru.manager.indexOf(this.userid) > -1)
        return 'Manager';
      return 'View Only';
    },
    getFilterRUList(_key = "", search = "") {
      void _key;
      const filterItemsCopy = JSON.parse(JSON.stringify(this.reportingunit_list))
      if (search) {
        var list = filterItemsCopy.filter((x) => {
          if (typeof this.selectedFilterItems !== 'undefined') {
            if ((x.code || "").toLowerCase().includes((search || "").toLowerCase())) {
              return x
            }
          } else {
            if (
              (x.code || "").toLowerCase().includes((search || "").toLowerCase())
            )
              return x || [];
          }
        });
        for (const i of this.selectedFilterItems || []) {
          const index = list.findIndex(item => item.value === i);
          if (index !== -1) {
            list.splice(index, 1);
          }
        }
        return list
      } else {
        if (typeof this.selectedFilterItems !== 'undefined') {
          for (const i of this.selectedFilterItems || []) {
            filterItemsCopy.filter(item => item.code !== i);
          }
          return filterItemsCopy
        } else {
          return this.reportingunit_list || [];
        }
      }
    },
    resetPage(resetIndex = true){
      if(resetIndex){
        this.page = 1;
        this.lastLoadedPage = 1;
      }
      this.paginatedData = [];
      this.allSelected = false;
      this.isIndeterminate = false;
      this.pendingPage = null;
    },
    userHasMultipleRoles(ruDetails) {
        if (!ruDetails) return false;
        let roleCount = 0;
        if ((ruDetails?.submitter || []).indexOf(this.userid) > -1) roleCount++;
        if ((ruDetails?.approver || []).indexOf(this.userid) > -1) roleCount++;
        if ((ruDetails?.regional_approver || []).indexOf(this.userid) > -1) roleCount++;
        if ((ruDetails?.manager || []).indexOf(this.userid) > -1) roleCount++;
        return roleCount > 1;
      },
    refreshData() {
      // Respect currentPage prop if provided (don't reset to 1)
      const shouldResetPage = !this.currentPage || this.currentPage === 1;
      this.resetPage(shouldResetPage);
      if (!shouldResetPage) {
        this.page = this.currentPage;
        this.lastLoadedPage = this.currentPage;
      }
      this.resetSelectionState();
      this.userid = this.$store.state.user.id;
      this.updatePaginationMeta();
      this.reportingunit_list = (this.$store.state[this.appname] || {}).actualhierarchydata?.reportingunitlist || [];
      this.dataLoading = false;
      this.pendingPage = null;
      this.lastLoadedPage = this.page;
    },
    sendEvent(type, value){
      if(!value){
        return;
      }
      if(this.type === 'Reporting Unit'){
        const reportingUnitId = value.reportingunit_detail?.['_id'] || value.reportingunit || value._id;
        const cycleId = this.getCycleId(value);
        const detailSource = value.reportingunit_detail || value.reporting_unit?.reportingunit_detail || value.reporting_unit || {};
        const normalizedDetail = {
          ...detailSource,
          _id: detailSource?._id || reportingUnitId,
        };
        // Check reporting_unit.context if no other source
        const ruContext = value.reporting_unit ? (value.reporting_unit.context || {}) : (value.context || {});

        const hierarchyContext = {
          network: this.resolveHierarchyId(value.network_detail || detailSource.network_detail || detailSource.network || ruContext.network),
          region: this.resolveHierarchyId(value.region_detail || detailSource.region_detail || detailSource.region || ruContext.region),
          country: this.resolveHierarchyId(value.country_detail || detailSource.country_detail || detailSource.country || ruContext.country),
          type: detailSource.type || detailSource.rutype || ruContext.type || ruContext.rutype
        };
        const payload = {
          reportingunit: reportingUnitId,
          cycle: cycleId,
          previousLoadedRUList: this.previousData,
          reportingunitDetail: normalizedDetail,
          hierarchyContext,
        };
        this.$emit(type, payload);
      }
      else this.$emit(type, value._id || value);
    },
    /**
     * Load more data - triggered by Load More button click
     * Disabled when using pagination (totalCount provided)
     */
    loadMoreData() {
      // Don't load more when using pagination
      if (this.totalCount && this.totalCount > 0) {
        return;
      }
      if (this.dataLoading || !this.hasMore || this.type !== 'Reporting Unit') {
        return;
      }
      this.dataLoading = true;
      this.$emit('getreportingunit', { loadMore: true });
    },
    // Ensure we have enough records available before navigating to a page
    // Ensure we have enough records available before navigating to a page
    ensureDataForPage(page) {
      if (!page || page < 1) {
        return;
      }
      const requiredItemCount = page * this.perpage;
      if (this.previousData.length === 0) {
        return;
      }
      if (this.previousData.length >= requiredItemCount) {
        return;
      }
      if (!this.hasMore || this.isfilteredData) {
        return;
      }
      this.loadMoreData();
    },
    /**
     * Load more data - triggered by Load More button click
     */
    // loadMoreData() {
    //   if (this.dataLoading || !this.hasMore || this.type !== 'Reporting Unit') {
    //     return;
    //   }
    //   this.dataLoading = true;
    //   this.$emit('getreportingunit', { loadMore: true });
    // },
    handleScroll(event) {
      // Disable infinite scroll when using pagination (when totalCount is provided)
      if (this.totalCount && this.totalCount > 0) {
        return;
      }

      const scrollElement = this.resolveScrollElement(event);
      if (!scrollElement) {
        return;
      }

      this.container = scrollElement;

      const scrollHeight = scrollElement.scrollHeight || 0;
      const clientHeight = scrollElement.clientHeight || 0;
      const scrollTop = scrollElement.scrollTop || 0;
      const hasScrollableContent = scrollHeight > clientHeight;
      const isNearBottom = scrollHeight - scrollTop <= clientHeight + 100;

      if (
        hasScrollableContent &&
        isNearBottom &&
        !this.dataLoading &&
        this.type === 'Reporting Unit' &&
        this.previousData.length > 0 &&
        !this.isfilteredData &&
        this.hasMore
      ) {
        this.dataLoading = true;
        this.$emit('getreportingunit', { loadMore: true });
      }
    },
    resolveScrollElement(event) {
      const target = event?.target;
      if (target && typeof target.scrollHeight === 'number') {
        return target;
      }

      if (this.$refs.tableScrollContainer && typeof this.$refs.tableScrollContainer.scrollHeight === 'number') {
        return this.$refs.tableScrollContainer;
      }

      if (this.$refs.cardScrollContainer && typeof this.$refs.cardScrollContainer.scrollHeight === 'number') {
        return this.$refs.cardScrollContainer;
      }

      if (typeof document !== 'undefined') {
        return document.scrollingElement || document.documentElement || null;
      }

      return null;
    },
    getPercentageProgress(n = 0, d = 0){
      if(n === 0 && d === 0) return 1;
      else return n/d;
    },
    getApproveRUData(ruid){
      this.approveRUDataDialogue = true;
      this.approveRUDataloading = true;
      this.approveRUData = {};
      let url = "/v2/varianceanalysis/analysis/getrulevelapprovaldata/"+ruid;
      helpers.apiGet.call(this, url).then(dt => {
        if(dt.data.status === "success") {
          this.approveRUData = dt.data?.data[0] || {};
        }
        else throw new Error (dt.data.message || "Error loading download list");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.approveRUDataloading = false;
      });
    },
    setHeader(d){
        this.selectedHeader = d;
    },
    removeSelectedFilterItem(item){
      //this.getaccessRUlist();
      this.reportingunit_list = [...[item], ...this.reportingunit_list];
      if(this.selectedFilterItems.length === 0){
        this.previousData = this.data || [];
        this.isfilteredData = false;
        this.resetPage();
        this.updatePaginationMeta();
      }
    },
    removeFilteredItems(){
      this.reportingunit_list = [...this.selectedFilterItems, ...this.reportingunit_list];
      this.selectedFilterItems =[];
      this.previousData = this.data || [];
      this.isfilteredData = false;
      this.resetPage();
      this.updatePaginationMeta();
    },

    handleTableFilterUpdate(filters) {
      if (this.filterDebounceTimer) {
        clearTimeout(this.filterDebounceTimer);
      }

      if (this.suppressFilterUpdate) return;

      this.filterDebounceTimer = setTimeout(() => {

        // Check if there are any actual active filters (non-empty arrays)
        const hasActiveFilters = filters && Object.values(filters).some(val => Array.isArray(val) ? val.length > 0 : !!val);

        // If filters is null, empty object, or has no active values, it implies logic to clear
        if (!hasActiveFilters) {
          // Prevent auto-reset when table receives empty data which makes table hide and might trigger filter clear internally
          // If we have no data displayed, user cannot clear filters manually (table is hidden), so this must be auto-reset.
          // We should ignore it to keep "No Data" state until user clicks explicit reset button.
          if (!this.previousData || this.previousData.length === 0) {
             return;
          }

          // If we were showing filtered data, refresh to show all
          // Or if we just want to ensure we track that filters are cleared.
          this.dataLoading = true;
          this.isTableFilterTriggered = true;
          this.$emit('getreportingunit', { 
            page: 1, 
            limit: this.perpage, 
            clearTableFilters: true
          });
          return;
        }

        const payload = {};
        const normalize = (str) => String(str || '').trim().toLowerCase();

        // 1. Process L1 Status (Local)
        if (filters.l1_status && filters.l1_status.length > 0) {
          const l1Codes = new Set();
          filters.l1_status.forEach(label => {
            const normalizedLabel = normalize(label);
            Object.entries(STATUS_CONFIG).forEach(([key, config]) => {
              if (normalize(config.label) === normalizedLabel) {
                  // Config key (variant) matches. Find codes for this variant.
                  Object.entries(STATUS_CODE_VARIANT_MAP).forEach(([code, variant]) => {
                    if (variant === key) {
                        l1Codes.add(parseInt(code));
                    }
                  });
              }
            });
          });
          if (l1Codes.size > 0) {
            payload.localRuLevelApprovalStatus = Array.from(l1Codes);
          }
        }

        // 2. Process L2 Status (Regional)
        if (filters.l2_status && filters.l2_status.length > 0) {
            const l2Codes = new Set();
            filters.l2_status.forEach(label => {
              const normalizedLabel = normalize(label);
              Object.entries(STATUS_CONFIG).forEach(([key, config]) => {
                  if (normalize(config.label) === normalizedLabel) {
                      Object.entries(STATUS_CODE_VARIANT_MAP_REGIONAL).forEach(([code, variant]) => {
                      if (variant === key) {
                          l2Codes.add(parseInt(code));
                      }
                      });
                  }
              });
            });
            if(l2Codes.size > 0) {
                payload.regionalRuLevelApprovalStatus = Array.from(l2Codes);
            }
        }

        // 3. Process User Role
        if (filters.user_role && filters.user_role.length > 0) {
          const apiRoles = new Set();
          
          filters.user_role.forEach(roleLabel => {
              const normalizedLabel = normalize(roleLabel);
              // Locate the role object in availableRoles matching the selected name
              const matchedRole = this.availableRoles.find(r => normalize(r.name) === normalizedLabel);
              
              if (matchedRole && matchedRole._id) {
                apiRoles.add(matchedRole._id);
              } else {
                // Fallback for unknown roles - use the original value
                apiRoles.add(roleLabel);
              }
          });
          
          if (apiRoles.size > 0) {
            payload.userRole = Array.from(apiRoles);
          }
        }

        // Emit with payload if we have any mapped filters, 
        // OR emit default if we have filters but failed to map (handle as basic reload or search if supported later)
        // For now, always emit to trigger the load.
        this.dataLoading = true;
        this.isTableFilterTriggered = true;
        // Don't auto-reset when no matches found - pass maintainFilters flag
        this.$emit('getreportingunit', { 
          page: 1, 
          limit: this.perpage, 
          maintainFilters: true,
          ...payload 
        });
      }, 500); // 500ms debounce
    },

    async getaccessFilterRUlist(){
      let selectedRUids = []
      this.selectedFilterItems.forEach((key)=>{
        selectedRUids.push(key._id);
      })
      if(selectedRUids.length>0){
        this.previousData = [];
        this.dataLoading = true
        this.resetPage();
      }
      for(let i=0;i<=(selectedRUids.length/10);i++ ){
        let response = await this.getFilteredListData(selectedRUids.slice((i) * 10, (i+1) * 10));
        this.previousData = [...this.previousData, ...response]
      }
      this.dataLoading = false
      this.updatePaginationMeta();
    },

    async getFilteredListData(rulist){
      let filters = {}
      if(this.cycletype === 'Forecast'){
        filters = ((this.$store.state[this.appname] || [])).forecastfilter;
      }
      else{
        filters = ((this.$store.state[this.appname] || [])).actualfilter;
      }
      Object.keys(filters).forEach((key) => {
        filters[key] = filters[key] || "";
      });
      // this.loading = true; // Avoid mutating prop
      return helpers.apiGet.call(this, "/v3/varianceanalysis/analysis/getreportingunit_pagination", { cycletype: this.cycletype, year: filters.selectedyear, role: filters.selectedrole, network: filters.selectednetwork, region: filters.selectedregion, country: filters.selectedcountry, period: filters.selectedperiod, reportingunits: rulist, limit: this.perpage }).then(dt => {
        if (dt.data.status === "success") {
          // this.previousData = dt.data.data  || [];
          this.isfilteredData = true;
          return (dt.data?.data || []);
        }
        else throw new Error(dt.data.message || "Error fetching data");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        // this.loading = false; // Avoid mutating prop
        // this.dataLoading = false; // Managed by caller (getaccessFilterRUlist)
      })
    },
    
    getFilterRUs(){
      let filters = {}
      if(this.cycletype === 'Forecast'){
        filters = ((this.$store.state[this.appname] || [])).forecastfilter;
      }
      else{
        filters = ((this.$store.state[this.appname] || [])).actualfilter;
      }
      Object.keys(filters).forEach((key) => {
        filters[key] = filters[key] || "all";
      });
      let selectedRUids = []
      this.selectedFilterItems.forEach((key)=>{
        selectedRUids.push(key._id);
      })
      this.reportingunit_list  =  (this.$store.state[this.appname] || {}).actualhierarchydata?.reportingunitlist || []
      this.reportingunit_list = this.reportingunit_list.filter((item)=> (filters.selectednetwork === 'all' || item.network === filters.selectednetwork) && (filters.selectedregion === 'all' || item.region === filters.selectedregion) && (filters.selectedcountry === 'all' || item.country === filters.selectedcountry) && selectedRUids.indexOf(item._id) === -1)
      
      if(filters.selectedrole === 'approver'){
        this.reportingunit_list = this.reportingunit_list.filter((item)=> item.approver?.indexOf(this.userid)!== -1)
      }else if(filters.selectedrole === "submitter"){
        this.reportingunit_list = this.reportingunit_list.filter((item)=> item.submitter?.indexOf(this.userid)>-1)
      }else if(filters.selectedrole === "regional_approver"){
        this.reportingunit_list = this.reportingunit_list.filter((item)=> item.regional_approver?.indexOf(this.userid)!== -1)
      }
      // this.reportingunit_list = this.reportingunit_list.filter(obj => new Date(obj.created_at).getFullYear() === filters.selectedyear);
    },
    /**
     * DISABLED: Auto-load removed - infinite scroll only triggers on user scroll to bottom
     * Keeping method stub to avoid breaking any external calls
     */
    tryLoadMoreIfNotScrollable() {
      // Disabled - only load more when user scrolls to bottom
      return;
    }
  },
  beforeDestroy() {
    // Clear pagination debounce timer to prevent memory leaks
    if (this.paginationDebounceTimer) {
      clearTimeout(this.paginationDebounceTimer);
      this.paginationDebounceTimer = null;
    }
    // Clear filter debounce timer
    if (this.filterDebounceTimer) {
      clearTimeout(this.filterDebounceTimer);
      this.filterDebounceTimer = null;
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  watch: {
    loading(val) {
      if (val) {
        this.previousData = [];
        this.updatePaginationMeta();
      } else {
        // Only reset dataLoading if no pending pagination request
        // This prevents race conditions when Apply/filter requests complete
        // but a pagination request is still in flight
        if (this.pendingPage === null && !this.paginationDebounceTimer) {
          this.dataLoading = false;
        }
      }
    },
    data: {
      handler(newData) {
        // Set flag to prevent pagination events during response processing
        this.isProcessingResponse = true;
        
        // For pagination mode with totalCount, replace data completely (server-side pagination)
        // For infinite scroll mode, append data
        if (this.view === 0 || this.view === 1 || this.view === 2) {
          // Always replace with new data from API (don't append for pagination)
          this.previousData = [...newData];
        }
        this.updatePaginationMeta();
        this.dataLoading = false;
        if (this.pendingPage !== null) {
          this.lastLoadedPage = this.pendingPage;
          this.pendingPage = null;
        }
        
        // Reset flag after Vue's next tick to allow future pagination events
        this.$nextTick(() => {
          this.isProcessingResponse = false;
        });
      },
      immediate: true
    },
    filtereddata: {
      handler() {
        this.pruneInvalidSelections();
        this.updateIndeterminate();
      },
      deep: true
    },
    shouldShowSelectionColumn(newValue) {
      if (!newValue) {
        if (this.selectedlocalapproval.length > 0) {
          this.selectedlocalapproval = [];
        }
        this.allSelected = false;
        this.isIndeterminate = false;
      } else {
        this.updateIndeterminate();
      }
    },
    page(newPage, oldPage) {
      if (newPage === oldPage) {
        return;
      }
      // Don't use ensureDataForPage for server-side pagination (when totalCount is provided)
      if (!this.totalCount || this.totalCount === 0) {
        this.ensureDataForPage(newPage);
      }
      this.updatePaginationMeta();
      if (!this.dataLoading) {
        this.lastLoadedPage = newPage;
      }
    },
    // Sync page with currentPage prop from parent
    currentPage: {
      handler(newPage) {
        const normalized = Math.max(1, Number(newPage) || 1);
        if (normalized !== this.page) {
          this.isApplyingExternalPage = true;
          this.page = normalized;
          this.lastLoadedPage = normalized;
        }
      },
      immediate: true,
    },
    pageSize(newSize) {
      const normalized = Math.max(1, Number(newSize) || varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE);
      if (normalized !== this.perpage) {
        this.perpage = normalized;
        this.resetPage();
        this.updatePaginationMeta();
      }
    },
    isDataRefreshed(newVal){
      if(newVal === true){
        this.selectedlocalapproval = [];
        this.selectedregionalapproval = [];
        this.selectedReportingUnits = [];
        this.previousData = []
        // Only reset page to 1 if we are not currently waiting for a specific page (pagination)
        this.resetPage(this.pendingPage === null);
        this.updatePaginationMeta();
        
        // Handle filter clearing logic:
        // If this refresh was triggered by the table filters themselves (isTableFilterTriggered),
        // we should NOT clear the filters again (just reset the flag).
        // If it was triggered by external source (isDataRefreshed=true from Base.vue/helpers.js
        // via Main Filter/Refresh button), then we DO clear the filters.
        if (this.isTableFilterTriggered) {
          this.isTableFilterTriggered = false;
        } else {
          // Clear table filters for external refreshes
          if (this.$refs.analysisTable) {
            this.suppressFilterUpdate = true;
            this.$refs.analysisTable.resetFilters();
            // Unset flag on next tick to allow future user interactions to trigger updates
            this.$nextTick(() => {
              this.suppressFilterUpdate = false;
            });
          }
        }
      }
    },
    selectedlocalapproval() {
      this.$emit('approvelocal', this.selectedlocalapproval);
      this.updateIndeterminate();
    },
    selectedReportingUnits() {
      this.$emit('multipleReminderMails', this.selectedReportingUnits);
    },
    selectedregionalapproval() {
      this.$emit('approveregional', this.selectedregionalapproval);
    },
    sendRemainderMail(reportingUnits) {
      this.$emit('sendRemainderMail', reportingUnits);
    },
    hasMore(newVal) {
      if (!newVal) {
        this.dataLoading = false;
      }
      this.updatePaginationMeta();
      // Removed auto-load - only load more on user scroll to bottom
    },
    filterValue: {
      handler(newVal) {
        if (this.selectedHeader !== "") {
          let matchedItem = [this.reportingunit_list.find(item=> item?._id === newVal[newVal.length-1])] || []
          this.reportingunit_list = this.reportingunit_list.filter(item => item?._id !== newVal[newVal.length - 1] );
          if(matchedItem.length >0 && typeof matchedItem[0] !== undefined){
            this.selectedFilterItems = [...this.selectedFilterItems, ...matchedItem]
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style>

/* ================================
   Transition Animations
   ================================ */

/* Table view: shimmer & data CSS-based fade transition */
.ru-table-fade-layer {
  animation: ruTableFadeIn var(--duration-smooth, 300ms) var(--ease-standard, ease) both;
}

@keyframes ruTableFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Content cross-fade: card skeleton ↔ cards, NoDataState */
.ru-content-fade-enter-active,
.ru-content-fade-leave-active {
  transition: opacity var(--duration-smooth, 300ms) var(--ease-out, ease),
              transform var(--duration-smooth, 300ms) var(--ease-out, ease);
}

.ru-content-fade-enter,
.ru-content-fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

/* Card view: individual card enter/leave */
.ru-card-enter-active {
  transition: opacity var(--duration-smooth, 300ms) var(--ease-out, ease),
              transform var(--duration-smooth, 300ms) var(--ease-out, ease);
}

.ru-card-leave-active {
  transition: opacity var(--duration-fast, 100ms) var(--ease-standard, ease);
}

.ru-card-enter {
  opacity: 0;
  transform: translateY(12px);
}

.ru-card-leave-to {
  opacity: 0;
}

/* Card reordering animation */
.ru-card-move {
  transition: transform var(--duration-smooth, 300ms) var(--ease-standard, ease);
}

.scrollable-table-container {
  max-height: 77vh;
  /* Adjust the maximum height as needed */
  overflow-y: auto;
  /* Enable vertical scrolling */
}
.scrollable-card {
  max-height: 300px; /* Set maximum height for scrollable card */
  overflow-y: auto; /* Enable vertical scrollbar */
}
.spinner-container {
  display: flex;
  justify-content: center; /* Horizontal centering */
  align-items: center; /* Vertical centering */
  height: 100%; /* Ensure it takes the full height of the parent */
}

.scroll {
  overflow-x: auto;
  max-height: 250px;
  width: 280px;
}

.single-line-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.datatable-home-page {
  /* Let parent container handle scrolling for infinite scroll to work */
  overflow: visible;
}
.datatable-home-page .v-data-table__wrapper {
  overflow: visible !important;
}
.datatable-home-page thead {
  position: sticky !important;
  top: 0 !important;
  z-index: 2 !important;
  box-shadow: 0 2px 2px -1px rgba(0,0,0,0.1);
}
.theme--dark .datatable-home-page th {
  background-color: #1e1e1e; 
}
.local-workflows p {
  color: #6d6d6d;
}

/* Accordion table styles */

.nested-table {
  border-collapse: collapse;
}
.nested-table th,
.nested-table td {
  padding: 18px 12px;
  border-bottom: 1px solid #e5e5e5;
}
.theme--dark .nested-table th,
.theme--dark .nested-table td {
  border-bottom: 1px solid #444;
}
.nested-table th { border-right: 0px solid; }
.theme--dark .nested-table th {
  background: #1e3a5f;
}
.nested-table tbody tr:hover {
  background: #f5f5f5;
}
.theme--dark .nested-table tbody tr:hover {
  background: #333;
}

.table-scroll-wrapper {
  position: relative;
}

.table-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  pointer-events: none;
  z-index: 3;
}

.theme--dark .table-loading-overlay {
  background: rgba(30, 30, 30, 0.6);
}

/* Expand icon styling */
.workflow-bar-container {
  display: flex;
  height: 12px;
  border-radius: 4px;
  overflow: hidden;
  /* min-width: 300px; */
}

.segment {
  height: 100%;
}

.ru-list__clickable-row {
  cursor: pointer;
  transition: background-color 0.2s ease;
  min-height: 64px;
}

/* Ensure table rows have proper height for status columns */
.ru-list-container tbody tr td {
  height: 64px;
  vertical-align: middle;
}

/* Status column cell styling for proper height */
.status-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 48px;
  padding: 8px 0;
}

.ru-list__clickable-row:hover {
  background-color: rgba(59, 130, 246, 0.08);
}

.theme--dark .ru-list__clickable-row:hover {
  background-color: rgba(59, 130, 246, 0.24);
}

/* Accordion chevron rotation */
.accordion-chevron {
  transition: transform 0.3s ease;
}

.accordion-chevron-rotated {
  transform: rotate(180deg);
}

.action-icons{
  border-radius: var(--space-xs, 8px);
  background: var(--text-icon-combo, #EDEDED);
  cursor: pointer;
  width: max-content;
}
.reason-comment{
  color: var(--grey-900, #2C2C35);
}

/* Container layout for fixed pagination */
.ru-list-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  position: relative;
  padding-bottom: 64px; /* Space for fixed pagination */
}

.ru-list-content-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: visible;
}

.ru-list-scrollable-content {
  flex: 1;
  min-height: 0;
}
.activity-img img{
  width: 16px;
  height: 16px;
}

</style>